import React from 'react';
import { showToast } from '@shared/services/toastService';
import { TOAST_MESSAGE_TYPES } from '@shared/constants/toastMessageTypes';
import { CacheInvalidatingToast } from '../../features/notifications/toastNotification/components/CacheInvalidatingToast';

export const showToastNotification = (notification, clearCache) => {
  const { type, notificationData } = notification;

  showToast(
    TOAST_MESSAGE_TYPES.INFO,
    <CacheInvalidatingToast
      notificationType={type}
      notificationData={notificationData}
      clearCache={clearCache}
    />,
    notificationData.notificationId,
    false
  );
};
